// extracted by mini-css-extract-plugin
export default {"parent":"leaseSlotSkeletonList_parent__3xxpo","container":"leaseSlotSkeletonList_container__ThM5+"};